import React from 'react'
import { useForm, usePage, Link } from '@inertiajs/react'
import { Mail, RefreshCw, CheckCircle2 } from 'lucide-react'
import AuthLayout from '@/layouts/AuthLayout'
import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Alert, AlertDescription } from '@/components/ui/alert'

type Props = {
  email: string
}

export default function PasswordSent({ email }: Props) {
  const { flash } = usePage().props
  const { post, processing } = useForm({ email })

  const handleResend = () => {
    post('/password')
  }

  return (
    <AuthLayout>
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
            <Mail className="h-8 w-8 text-primary" />
          </div>
          <CardTitle className="text-xl">メールを確認してください</CardTitle>
          <CardDescription>パスワードリセットメールを送信しました</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {flash?.notice && (
            <Alert>
              <CheckCircle2 className="h-4 w-4" />
              <AlertDescription>{flash.notice}</AlertDescription>
            </Alert>
          )}

          <p className="text-center text-sm text-muted-foreground">
            以下のメールアドレスにパスワードリセット用のリンクを送信しました。
            メール内のリンクをクリックして新しいパスワードを設定してください。
          </p>

          <p className="rounded-lg bg-muted px-4 py-3 text-center font-medium">
            {email}
          </p>

          <div className="space-y-2 text-center text-sm text-muted-foreground">
            <p>メールが届かない場合は、迷惑メールフォルダをご確認ください。</p>
            <p>
              リセットリンクの有効期限は <span className="font-medium">6時間</span>{' '}
              です。
            </p>
          </div>
        </CardContent>
        <CardFooter className="flex flex-col gap-4">
          <Button
            onClick={handleResend}
            disabled={processing}
            variant="outline"
            className="w-full"
          >
            <RefreshCw
              className={`mr-2 h-4 w-4 ${processing ? 'animate-spin' : ''}`}
            />
            メールを再送信
          </Button>
          <p className="text-sm text-muted-foreground">
            ログイン画面に戻る{' '}
            <Link href="/login" className="text-primary hover:underline">
              ログイン
            </Link>
          </p>
        </CardFooter>
      </Card>
    </AuthLayout>
  )
}
